export const DEFAULT_CEM_RATINGS = [
  { id: 'no_localizable', label: 'No Localizable', seller_score: 1, color: '#64748B' },
  { id: 'localizable_sin_interes', label: 'Localizable sin Interés', seller_score: 3, color: '#F59E0B' },
  { id: 'interesado', label: 'Interesado', seller_score: 6, color: '#3B82F6' },
  { id: 'muy_interesado', label: 'Muy interesado', seller_score: 9, color: '#22C55E' },
  { id: 'muy_interesado_no_perfilado', label: 'Muy interesado no perfilado', seller_score: 7, color: '#A855F7' },
];

export const LEGACY_STATUS_LABELS = {
  nuevo: 'Nuevo (histórico)',
  prospecto: 'Prospecto (histórico)',
  contactado: 'Contactado (histórico)',
  calificado: 'Calificado (histórico)',
  negociacion: 'Negociación (histórico)',
  ganado: 'Ganado (histórico)',
  perdido: 'Perdido (histórico)',
};

export function ratingLabel(id, catalog) {
  const hit = (catalog || []).find(r => r.id === id);
  if (hit) return hit.label;
  return LEGACY_STATUS_LABELS[id] || id || 'Sin calificar';
}

export function ratingColorClass(id) {
  return {
    no_localizable: 'status-perdido',
    localizable_sin_interes: 'status-contactado',
    interesado: 'status-prospecto',
    muy_interesado: 'status-ganado',
    muy_interesado_no_perfilado: 'status-calificado',
    nuevo: 'status-nuevo',
    prospecto: 'status-prospecto',
    contactado: 'status-contactado',
    calificado: 'status-calificado',
    negociacion: 'status-negociacion',
    ganado: 'status-ganado',
    perdido: 'status-perdido',
  }[id] || 'status-nuevo';
}
